import React from 'react';
import CardKeyValue from '../../../../../card/cardKeyValue';
import TextFormatDateRange from '../../../../../text/TextFormatDateRange';
import { getValueElement } from '../../TableCompare/utils';
import { Typography } from '@mui/material';

const CardsInformation = ({ detail }) => (
  <>
    <div className='flex flex-nowrap gap-4 pb-2 items-strech justify-center overflow-auto'>
      {detail?.curriculumElements?.elementId && (
        <CardKeyValue
          className='min-w-100px max-w-150px'
          lines={2}
          title={detail?.curriculumElements?.elementId?.keyName}
          value={
            detail?.curriculumElements?.elementId?.valueName || detail?.curriculumElements?.elementId?.value
          }
        />
      )}
      {detail?.curriculumElements?.subElementId && (
        <CardKeyValue
          className='min-w-100px max-w-150px'
          lines={2}
          title={detail?.curriculumElements?.subElementId?.keyName}
          value={
            detail?.curriculumElements?.subElementId?.valueName ||
            detail?.curriculumElements?.subElementId?.value
          }
        />
      )}
      {detail.subjectId && (
        <CardKeyValue
          className='min-w-100px max-w-150px'
          lines={2}
          title='Subject'
          value={detail.subjectId.name || ''}
        />
      )}
      <CardKeyValue className='min-w-100px max-w-150px' title='Name' lines={2} value={detail.name || ''} />
      <CardKeyValue
        className='min-w-100px max-w-150px'
        title='Year level'
        lines={2}
        value={detail.yearLevel?.map((year) => year?.name || year?._id || year).join(', ') || ''}
      />
      <CardKeyValue
        className='min-w-130px max-w-130px'
        title='Period'
        lines={2}
        tooltip={false}
        value={
          <TextFormatDateRange
            className='text-sm text-center'
            startDate={detail.startDate}
            endDate={detail.endDate}
          />
        }
      />
    </div>
    <div className='flex flex-nowrap gap-4 pb-2 items-strech justify-center overflow-auto'>
      {detail.lc && (
        <CardKeyValue
          title='Learning Continua'
          value={getValueElement(detail?.lc?.lcElements, 'lcElements')}
          lines={2}
        />
      )}
      {detail.gs && (
        <CardKeyValue
          title='Granular step'
          className={' max-w-350px'}
          lines={2}
          value={
            <>
              <div className='flex gap-2'>
                <Typography
                  className='text-sm font-bold text-ellipsis text-nowrap max-w-50px text-left'
                  variant='inherit'
                  component='span'
                >
                  Level
                </Typography>
                <Typography className='text-sm text-ellipsis text-nowrap' variant='inherit' component='span'>
                  {detail.gs.name || detail.gs.levelId}
                </Typography>
              </div>
              <div className='flex gap-2'>
                <Typography
                  className='text-sm font-bold text-ellipsis text-nowrap max-w-50px text-left'
                  variant='inherit'
                  component='span'
                >
                  Definiton
                </Typography>
                <Typography className='text-sm text-ellipsis text-nowrap' variant='inherit' component='span'>
                  {detail.gs?.definition}
                </Typography>
              </div>
            </>
          }
        />
      )}
    </div>
  </>
);

export default CardsInformation;
